/* Ayakkabı Prensi — üyeliksiz favoriler (localStorage). Idempotent: birden fazla kez yüklense de bir kez çalışır. */
(function () {
  if (window.APWishlist) return;
  var KEY = 'ap_wishlist_v1';

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: list } }));
  }
  function has(handle) { return read().indexOf(handle) > -1; }
  function toggle(handle) {
    var list = read(), i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.unshift(handle);
    write(list);
    return list.indexOf(handle) > -1;
  }
  function count() { return read().length; }

  function syncButton(btn) {
    var on = has(btn.getAttribute('data-handle'));
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.classList.toggle('is-active', on);
    var label = on ? btn.getAttribute('data-label-remove') : btn.getAttribute('data-label-add');
    if (label) { btn.setAttribute('aria-label', label); btn.setAttribute('title', label); }
    var txt = btn.querySelector('[data-wishlist-text]');
    if (txt && label) txt.textContent = label;
  }
  function syncAll() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(syncButton);
    var n = count();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      if (el.hasAttribute('data-wishlist-count-hide-empty')) el.hidden = n === 0;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-wishlist-toggle]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    var nowOn = toggle(handle);
    btn.classList.add('ap-wl-pop');
    setTimeout(function () { btn.classList.remove('ap-wl-pop'); }, 320);
    // favoriler sayfasındaysak ve çıkarıldıysa kartı kaldır
    if (!nowOn) {
      var card = btn.closest('[data-wishlist-item]');
      if (card) {
        card.style.transition = 'opacity .2s ease';
        card.style.opacity = '0';
        setTimeout(function () { card.remove(); renderPage(true); }, 200);
      }
    }
  });

  document.addEventListener('wishlist:change', function () { syncAll(); });

  /* Favoriler sayfası: temanın KENDİ kart şablonunu çekip basar (tasarım birebir aynı) */
  function renderPage(skipFetch) {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var items = read();
    var empty = document.querySelector('[data-wishlist-empty]');
    var head = document.querySelector('[data-wishlist-head]');
    if (!items.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      if (head) head.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (head) head.hidden = false;
    if (skipFetch) return;

    grid.setAttribute('aria-busy', 'true');
    Promise.all(items.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '?view=wishlist-card', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (parts) {
      var ok = parts.filter(function (p) { return p && p.trim(); });
      // artık var olmayan ürünleri listeden temizle
      if (ok.length !== items.length) {
        var kept = [];
        parts.forEach(function (p, i) { if (p && p.trim()) kept.push(items[i]); });
        try { localStorage.setItem(KEY, JSON.stringify(kept)); } catch (e) {}
      }
      grid.innerHTML = ok.join('');
      grid.removeAttribute('aria-busy');
      syncAll();
    });
  }

  window.APWishlist = { read: read, has: has, toggle: toggle, count: count, sync: syncAll, render: renderPage };

  function init() { syncAll(); renderPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { syncAll(); renderPage(); });
})();
